import { t } from "i18next";

export enum SystemClaim {
    AccessPatientsGrid = 'AccessPatientsGrid',
    AccessAppointmentsGrid = 'AccessAppointmentsGrid',
    AccessPrescriptionsGrid = 'AccessPrescriptionsGrid',
    AccessUserManagementMenu = 'AccessUserManagementMenu',
}

export const getSystemClaimLabel = (claim: SystemClaim): string => {
    switch (claim) {
        case SystemClaim.AccessPatientsGrid:
            return t('roles.systemClaims.accessPatientsGrid');
        case SystemClaim.AccessAppointmentsGrid:
            return t('roles.systemClaims.accessAppointmentsGrid');
        case SystemClaim.AccessPrescriptionsGrid:
            return t('roles.systemClaims.accessPrescriptionsGrid');
        case SystemClaim.AccessUserManagementMenu:
            return t('roles.systemClaims.accessUserManagementMenu');
    }
};
